module.exports = __webpack_public_path__ + "static/img/11.722c6b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/sp/11.png
// module id = eU6b
// module chunks = 0